<template>
  <div>
    <a-table
      :rowKey="Math.random"
      :bordered="false"
      :pagination="false"
      :columns="this.columnv"
      :dataSource="this.footerDataSource"
      :scroll="this.scrolls"
      :showHeader="false"
      size="small"
    ></a-table>
  </div>
</template>

<script>
export default {
  props: {
    columnv: {
      type: Array,
      default: () => ([])
    },
    footerDataSource: {
      type: Array,
      default: () => ([])
    },
    scrolls: {
      type: Object
    }
  }
}
</script>

<style lang="less" scoped>
/deep/ .ant-table {
  .ant-table-body-inner {
    overflow: auto !important;
  }
}
</style>



// WEBPACK FOOTER //
// src/views/common/totals.vue